import Snapshots from "./Snapshots";

export default Snapshots;
